import { Component, OnInit, Input } from '@angular/core';
import { trigger, transition, useAnimation } from '@angular/animations';
import { fadeInDown } from 'ng-animate';
import { Router, ActivatedRoute } from '@angular/router';
import { ApirequestService } from '../../../services/apirequest/apirequest.service';
import { ApiurlsService } from '../../../services/api-urls/apiurls.service';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'hybse-admin-invitation',
  templateUrl: './invitation.component.html',
  styleUrls: ['./invitation.component.css'],
  animations: [
    trigger('fadeInDown', [transition('* => *', useAnimation(fadeInDown, {
      params: {
        timing: 1,
        a: '-10px'
      }
    }))])
  ],
})
export class InvitationComponent implements OnInit {

  allInvitationList: any = [];
  fadeInDown: any;
  showLoader: boolean = false;
  public errorMessage: string;
  constructor(private route: Router,
    private _req: ApirequestService,
    private _urls: ApiurlsService,
    private dialog: MatDialog,
    private _ar: ActivatedRoute) { }

  ngOnInit() {
    this.getInvitationList();
  }

  getInvitationList() {
    this._req.fetchApiData(this._urls.listInvitationUrl, {}).subscribe(
      (data: any) => {
        let response = data.data;
        let resError = data.error;
        if (response !== '') this.allInvitationList = response;
        if (resError !== '') this.errorMessage = resError['Error Description'];
      },
      error => {
      },
      () => {
      }
    );
  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/invitation/invitation.component.ts